import { render, staticRenderFns } from "./declaracaoFormularioView.vue?vue&type=template&id=f0ff431e&scoped=true&"
import script from "./declaracaoFormularioView.vue?vue&type=script&lang=js&"
export * from "./declaracaoFormularioView.vue?vue&type=script&lang=js&"
import style0 from "./declaracaoFormularioView.vue?vue&type=style&index=0&id=f0ff431e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ff431e",
  null
  
)

export default component.exports